(() => {
  const cartPage = document.querySelector('.cart-page');
  if (cartPage) {
    const html = document.documentElement;
    const component = cartPage.closest('cart-items-component') || cartPage.parentElement;
    let checkoutBar;
    let resizeObserver;
    let scheduled = false;
    function updateCheckoutBar() {
      scheduled = false;
      const nextBar = component.querySelector('.cart-page__summary [data-sitr-cart-checkout]');
      if (nextBar !== checkoutBar) {
        resizeObserver?.disconnect();
        checkoutBar = nextBar;
        if (checkoutBar && window.ResizeObserver) {
          resizeObserver = new ResizeObserver(scheduleCheckoutBar);
          resizeObserver.observe(checkoutBar);
        }
      }
      html.classList.toggle('sitr-cart-mobile-ready', !!checkoutBar);
      html.style.setProperty('--sitr-checkout-height', checkoutBar ? `${Math.ceil(checkoutBar.getBoundingClientRect().height)}px` : '0px');
      const focused = document.activeElement;
      const editing = !!focused?.matches('input, textarea, [contenteditable="true"]');
      html.classList.toggle('sitr-cart-input-active', editing);
      if (checkoutBar && focused instanceof HTMLElement && focused !== document.body && !checkoutBar.contains(focused) && !editing && getComputedStyle(checkoutBar).position === 'fixed' && !document.querySelector('dialog[open]')) {
        const viewportBottom = window.visualViewport ? window.visualViewport.offsetTop + window.visualViewport.height : window.innerHeight;
        const visibleBottom = viewportBottom - checkoutBar.getBoundingClientRect().height - 12;
        const focusBottom = focused.getBoundingClientRect().bottom;
        if (focusBottom > visibleBottom) window.scrollBy(0, focusBottom - visibleBottom);
      }
    }
    function scheduleCheckoutBar() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(updateCheckoutBar);
    }
    new MutationObserver(scheduleCheckoutBar).observe(component, { childList: true, subtree: true });
    document.addEventListener('focusin', scheduleCheckoutBar);
    document.addEventListener('focusout', scheduleCheckoutBar);
    window.addEventListener('resize', scheduleCheckoutBar);
    window.visualViewport?.addEventListener('resize', scheduleCheckoutBar);
    window.addEventListener('pageshow', scheduleCheckoutBar);
    scheduleCheckoutBar();
  }
  const dialog = document.getElementById('sitr-added-dialog');
  const configNode = document.getElementById('sitr-cart-config');
  if (!dialog || !configNode) return;
  const config = JSON.parse(configNode.textContent);
  const copy = JSON.parse(document.getElementById('sitr-copy-config')?.textContent || '{}');
  const root = window.Shopify?.routes?.root || config.root || '/';
  let shown = false;
  try { shown = sessionStorage.getItem('sitr-added-offer-shown') === '1'; } catch (_) {}

  // The server-rendered cart panel is shared by the bag, drawer, and existing confirmation.
  // It uses actual line components, availability, discount totals, and the locale's routes.
  async function renderCart() {
    const response = await fetch(root + 'cart', {cache:'no-store'});
    if (!response.ok) throw new Error(copy.cart_check);
    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    const benefits = page.querySelector('[data-sitr-cart-benefits]');
    const host = dialog.querySelector('[data-sitr-added-benefits]');
    host.replaceChildren();
    if (benefits) host.append(document.importNode(benefits, true));
    const upsell = page.querySelector('[data-sitr-cart-upsell]');
    if (upsell && upsell !== benefits) host.append(document.importNode(upsell, true));
  }
  dialog.querySelectorAll('[data-sitr-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => { if (event.target === dialog) {const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();} });
  document.addEventListener('sitr:cart-added', async event => {
    if (event.detail?.inlineConfirmation || shown) return;
    shown = true;
    try { await renderCart(); dialog.showModal(); try { sessionStorage.setItem('sitr-added-offer-shown','1'); } catch (_) {} }
    catch (_) { shown = false; }
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-sitr-upsell-variant]');
    if (!select) return;
    const form = select.closest('[data-sitr-upsell-form]');
    const option = select.selectedOptions[0];
    const valid = !!select.value && !!option && !option.disabled;
    form.querySelector('button[type="submit"]').disabled = !valid;
    const price = form.querySelector('[data-sitr-upsell-price]');
    if (valid) price.textContent = option.dataset.money;
    const forecast = form.querySelector('[data-sitr-quantity-forecast]');
    if (forecast) {
      forecast.hidden = true;
      if (valid && form.dataset.quantitySafe === 'true') {
        const originals = JSON.parse(form.dataset.quantityLines);
        const rate = Number(form.dataset.quantityNextRate);
        const nextTotal = originals.reduce((sum, line) => sum + line - Math.floor(line * rate + 0.000001), 0)
          + Number(option.dataset.cents) - Math.floor(Number(option.dataset.cents) * rate + 0.000001);
        const extra = nextTotal - Number(form.dataset.quantityCurrent);
        const money = cents => new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: 'EGP' }).format(cents / 100);
        const original = Number(form.dataset.quantityOriginal);
        const current = Number(form.dataset.quantityCurrent);
        const newSavings = original + Number(option.dataset.cents) - nextTotal;
        const moreSavings = newSavings - (original - current);
        const newBagTotal = Number(form.dataset.cartCurrent) + extra;
        const totalSavings = Number(form.dataset.cartSavings) + moreSavings;
        if (![extra, newSavings, moreSavings, newBagTotal, totalSavings].every(Number.isFinite) || extra < 0 || moreSavings < 0) return;
        const lines = [
          form.dataset.estimateSavings.replace('__TOTAL__', money(totalSavings)).replace('__EXTRA__', money(moreSavings)),
          form.dataset.estimateExtra.replace('__AMOUNT__', money(extra)),
          form.dataset.estimateTotal.replace('__AMOUNT__', money(newBagTotal)),
          form.dataset.estimateNote,
        ];
        forecast.replaceChildren(...lines.map((text, index) => {
          const node = document.createElement(index === 0 ? 'strong' : 'p');
          node.textContent = text;
          return node;
        }));
        forecast.hidden = false;
      } else if (valid) {
        forecast.textContent = form.dataset.estimateUnavailable;
        forecast.hidden = false;
      }
    }
    const image = form.querySelector('[data-sitr-upsell-image]');
    image.hidden = !valid || !option.dataset.image;
    if (!image.hidden) { image.src=option.dataset.image;image.alt=select.closest('[data-sitr-contextual-offer]').querySelector('strong').textContent+' — '+option.textContent; }
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-sitr-upsell-form]');
    if (!form) return;
    const select = form.querySelector('[data-sitr-upsell-variant]');
    if (form.dataset.submitting || !select.value || select.selectedOptions[0]?.disabled) { event.preventDefault(); return; }
    form.dataset.submitting = 'true';
    const button = form.querySelector('button[type="submit"]');
    button.disabled = true;
    button.textContent = copy.adding;
    // Native POST returns to the localized bag, so its allocations and total come from Shopify.
  });
  window.addEventListener('pageshow', event => {
    // A cached bag must not restore an already-added recommendation or stale paid totals.
    if (event.persisted && /\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    document.querySelectorAll('[data-sitr-upsell-form]').forEach(form => {
      delete form.dataset.submitting;
      const select=form.querySelector('[data-sitr-upsell-variant]');
      const button=form.querySelector('button[type="submit"]');
      button.disabled=!select.value || !!select.selectedOptions[0]?.disabled;
      button.textContent=document.documentElement.lang==='ar'?'أضيفي القطعة المختارة':'Add the selected piece';
    });
    if (dialog.open) renderCart().catch(() => dialog.close());
  });
})();

